var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.difficultyText)?_c('recipe-label',{attrs:{"value":_vm.difficultyText,"icon":"far fa-smile-wink"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }